'use client'

import { ErrorBlock } from '@/components/common/ErrorBlock'
import { PackageFontMana } from '@/components/common/PackageFontMana'
import { StyledContent } from '@/components/common/StyledContent'
import { usePage } from '@/components/providers/PageProvider'
import { ParsedContentProvider, useParsedContent } from '@/components/providers/ParsedContentProvider'
import { createDynamicComponent } from '@/utils/factoryUtil'

import styles from './WPPage.module.scss'

const ArticleReport = createDynamicComponent({
  loader: () => import('@/components/common/Article'),
  name: 'ArticleReport',
})

export const WPPage = () => {
  const { page } = usePage()
  const { content, isPreview, slug, title } = page?.article || {}

  if (!content) return <ErrorBlock />

  return (
    <ParsedContentProvider articleSlug={slug} articleTitle={title} content={content} getReport={isPreview}>
      <WPPageInner />
    </ParsedContentProvider>
  )
}

const WPPageInner = () => {
  const { content, reports } = useParsedContent()
  const { page } = usePage()
  const { title } = page?.article || {}

  return (
    <section className={styles.container}>
      <PackageFontMana />
      <div className={styles.content}>
        {reports && <ArticleReport reports={reports} />}
        <StyledContent>
          {title && <h1 dangerouslySetInnerHTML={{ __html: title }} />}
          {content}
        </StyledContent>
      </div>
    </section>
  )
}
